import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Cookie } from '@mui/icons-material';

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if the user has already responded to the cookie consent
    const consent = window.localStorage.getItem('cookie-consent');
    if (!consent) {
      // Small delay to make the entrance transition feel deliberate and smooth
      const timer = window.setTimeout(() => {
        setIsVisible(true);
      }, 1000);
      return () => window.clearTimeout(timer);
    }
  }, []);

  const handleAcceptAll = () => {
    window.localStorage.setItem('cookie-consent', 'accepted');
    setIsVisible(false);
  };

  const handleDecline = () => {
    window.localStorage.setItem('cookie-consent', 'declined');
    setIsVisible(false);
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: 'spring', stiffness: 260, damping: 25 }}
          className='fixed bottom-6 left-6 right-6 md:left-auto md:right-8 md:max-w-md z-[9999] bg-[#0f2c3a]/95 backdrop-blur-md border border-white/10 shadow-2xl rounded-2xl p-6 text-white'
        >
          <div className='flex items-start gap-4'>
            <div className='p-2.5 bg-[#a8d35e]/10 rounded-xl text-[#a8d35e] shrink-0'>
              <Cookie className='w-6 h-6 animate-pulse' />
            </div>
            <div className='flex-1'>
              <h3 className='font-bold text-lg mb-2 flex items-center gap-2'>
                Valorizamos sua privacidade
              </h3>
              <p className='text-sm text-gray-300 leading-relaxed mb-4'>
                Utilizamos cookies essenciais para autenticação, funcionamento
                do simulador e acompanhamento do seu progresso de aprendizagem
                na plataforma. Para saber mais, acesse nossa{' '}
                <Link
                  to='/privacidade'
                  className='text-[#a8d35e] hover:underline font-medium transition-colors'
                >
                  Política de Privacidade
                </Link>
                .
              </p>
              <div className='flex flex-col sm:flex-row items-center gap-3'>
                <button
                  onClick={handleDecline}
                  className='w-full sm:w-auto px-4 py-2 text-xs font-semibold tracking-wide border border-white/20 hover:bg-white/10 rounded-lg transition-all text-gray-200 hover:text-white'
                >
                  Apenas Necessários
                </button>
                <button
                  onClick={handleAcceptAll}
                  className='w-full sm:flex-1 bg-[#a8d35e] hover:bg-[#97be53] text-[#0f2c3a] font-bold py-2.5 px-4 rounded-lg text-xs tracking-wide transition-all shadow-md hover:shadow-lg active:scale-[0.98]'
                >
                  Aceitar Todos
                </button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieConsent;
